import React, {useState} from 'react'
import "./index.scss"
import WeChat from "./WeChat.svg";

export function WeChatQR({qr}) {
    const [position, setPosition] = useState({
        left: 0,
        top: 0
    });

    function handleGetPosition(e) {
        const rect = e.target.getBoundingClientRect();
        setPosition({
            left: rect.left + rect.width + 5,
            top: rect.top - 36
        })
    }

    return (
        <>
            <span className='wechat-qr-wrapper' onMouseEnter={handleGetPosition}>
                <img className='wechat-icon' src={WeChat}/>
                <img className='wechat-qr' src={qr} style={position}/>
            </span>
        </>
    )
}